'use client';

import React, { useEffect, useState } from 'react';
import Reveal from '@/components/ui/Reveal';

const stats = [
  { value: 20, suffix: '+', label: 'Years of Service', icon: '🏥' },
  { value: 15000, suffix: '+', label: 'Patients Treated', icon: '❤️' },
  { value: 30, suffix: '+', label: 'Medical Specialists', icon: '👨‍⚕️' },
  { value: 24, suffix: '/7', label: 'Emergency Care', icon: '🚑' },
];

function AnimatedValue({ value, suffix }: { value: number; suffix: string }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const start = performance.now();
    const duration = 1200;
    const animate = (now: number) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(value * eased));
      if (progress < 1) requestAnimationFrame(animate);
    };
    const frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [value]);

  return <>{count.toLocaleString()}{suffix}</>;
}

export default function StatsBar() {
  return (
    <section className="bg-[#0D7377] py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats?.map((stat, index) => (
            <Reveal key={stat?.label} delay={index * 90}>
            <div className="text-center stats-item">
              <div className="text-2xl mb-1">{stat?.icon}</div>
              <div className="text-3xl font-bold text-[#F8FAFB] font-display mb-1"><AnimatedValue value={stat.value} suffix={stat.suffix} /></div>
              <div className="text-sm text-[rgba(248,250,251,0.75)] font-medium">{stat?.label}</div>
            </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
